// @ts-check
import { TimeOffsetToMinutes } from './constants';
import { DateTime } from 'luxon';
import _ from 'lodash';

export const timeRangeToTimeSpan = (timeRange, now) => {
  if (timeRange?.offset) {
    const timeNow = now ?? DateTime.local();
    const offset = TimeOffsetToMinutes[timeRange.offset];
    return {
      from: timeNow.minus({ minutes: offset }),
      to: timeNow
    };
  }
  // Convert from string to date time
  return {
    from: DateTime.fromISO(timeRange?.from),
    to: DateTime.fromISO(timeRange?.to)
  };

};

/**
 * @param {number} wait
 * @returns {() => Date}
 */
export const throttleDate = (wait) =>
  /** @type {() => Date}*/(/** @type {unknown} */
    (_.throttle(() => DateTime.local(), wait, { leading: true })));
